import { listRecentWebEventDrafts } from "./webEventRepository";
import { listActiveUserCount } from "./presenceRepository";

function isActiveEvent(item) {
  const status = String(item?.status || "draft").toLocaleLowerCase("tr-TR");
  return status !== "archived" && status !== "cancelled";
}

export async function getFooterLiveStats() {
  const [events, activeUsers] = await Promise.all([
    listRecentWebEventDrafts({ max: 400 }),
    listActiveUserCount({ windowMinutes: 5, max: 400 }),
  ]);

  const activeEventCount = events.filter(isActiveEvent).length;
  return { activeEventCount, activeUsers };
}
